module.exports = __webpack_public_path__ + "static/media/IMG_8572.af25b232.JPG";